import React, { useState, useEffect } from 'react';
import { quizQuestions, getScoreMessage, calculateQuizScore } from '../../data/quizData';
import QuizQuestion from '../quiz/QuizQuestion';
import QuizScore from '../quiz/QuizScore';

const QuizSection = () => {
  const [answers, setAnswers] = useState({
    question1: true,
    question2: true,
    question3: true,
    question4: true,
    question5: true,
    question6: true,
    question7: true
  });

  const [displayedPercentage, setDisplayedPercentage] = useState(100);

  const handleAnswerChange = (questionId, currentValue) => {
    setAnswers(prev => ({
      ...prev,
      [questionId]: !currentValue
    }));
  };

  // Animation effect for percentage counter
  useEffect(() => {
    const targetPercentage = calculateQuizScore(answers);

    if (displayedPercentage !== targetPercentage) {
      const increment = displayedPercentage < targetPercentage ? 1 : -1;
      const timer = setInterval(() => {
        setDisplayedPercentage(prev => {
          const next = prev + increment;
          if ((increment > 0 && next >= targetPercentage) || (increment < 0 && next <= targetPercentage)) {
            clearInterval(timer);
            return targetPercentage;
          }
          return next;
        });
      }, 20);

      return () => clearInterval(timer);
    }
  }, [answers, displayedPercentage]);

  const score = calculateQuizScore(answers);

  return (
    <section className="bg-white py-20 px-4" id="technical-readiness-quiz">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-apple-gray-800 mb-6 leading-tight">
            If You Can't Answer "Yes" to All These Questions, You Need Help
          </h2>
          <p className="text-lg text-apple-gray-600 max-w-2xl mx-auto">
            Take this quick assessment to identify critical gaps in your technical leadership readiness.
          </p>
        </div>

        {/* Quiz Questions */}
        <div className="max-w-3xl mx-auto mb-8">
          <div className="space-y-6">
            {quizQuestions.map((question, index) => (
              <QuizQuestion
                key={question.id}
                question={question}
                index={index}
                isAnswered={answers[question.id]}
                onAnswerChange={handleAnswerChange}
              />
            ))}
          </div>
        </div>

        {/* Score Display */}
        <QuizScore
          displayedPercentage={displayedPercentage}
          scoreMessage={getScoreMessage(score)}
          showCallToAction={score < 100}
        />
      </div>
    </section>
  );
};

export default QuizSection;